import { useContext } from "react"
import { StudentContext } from "../context/StudentContext"

export const useNoBtwPlichtigStudents = () => {
  const { studentState } = useContext(StudentContext)

  return studentState.students.filter((s) => s.btwPlichtig === undefined)
}
